// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/views/SrcView/style.css
// module id = 2416
// module chunks = 193